const style = (theme) => {
  const output = {
    root: {
      position: 'fixed',
      zIndex: theme.zindex.modal,
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      background: theme.getRgba(theme.colors[2], 0.7),
      opacity: 0,
      display: 'none',
    },
    wrapper: {
      background: theme.colors[1],
      position: 'absolute',
      zIndex: 1,
      transform: 'translate(-50%, -50%)',
      top: '50%',
      left: '50%',
      borderRadius: 27,
      maxWidth: 'calc(100% - 40px)',
      width: 950,
      overflow: 'hidden',
    },
    close: {
      position: 'absolute',
      zIndex: 20,
      width: 46,
      height: 46,
      border: `1px solid ${theme.getRgba(theme.colors[0], 0.2)}`,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      cursor: 'pointer',
      outline: 'none',
      borderRadius: '50%',
      top: 10,
      right: 10,
      '& svg': {
        fill: theme.colors[0],
        width: 10,
        height: 10,
      },
    },
    content: {
      position: 'relative',
      zIndex: 1,
      display: 'flex',
      '& form': {
        margin: [20, -10, 0],
        '& *': {
          textAlign: 'left!important',
        },
        '& a': {
          textDecoration: 'underline',
        },
        '& .Form__message': {
          color: theme.colors[2],
        },
      },
    },
    image: {
      flex: '0 0 300px',
      position: 'relative',
      zIndex: 1,
      '& img': {
        position: 'absolute',
        height: '100%',
        width: '100%',
        zIndex: 1,
        objectFit: 'cover',
      },
    },
    box: {
      padding: [40, 70, 40, 30],
    },
  }

  /*------------------------------
  SM
  ------------------------------*/
  output[theme.mediaInverse.sm] = {
    image: {
      display: 'none',
    },
  }

  return output
}

export default style
